import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

import { Task } from '@work4all/models/lib/Classes/Task.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { Tooltip } from '../../tooltip/Tooltip';
import { HookedUserIcon } from '../../user-icon/useUserIconRegister';
import { ListEntityPicker } from '../components/list-entity-picker/ListEntityPicker';
import { IPickerProps } from '../types';

export type ITaskPickerProps<TMultiple extends boolean> = IPickerProps<
  Task,
  TMultiple
>;

const DEFAULT_SORT_BY = 'title';
const DEFAULT_SORT_BY_DIRECTION = SortDirection.ASCENDING;

export function TaskPicker<TMultiple extends boolean>(
  props: ITaskPickerProps<TMultiple>
) {
  const {
    data,
    sortBy = DEFAULT_SORT_BY,
    sortByDirection = DEFAULT_SORT_BY_DIRECTION,
    ...rest
  } = props;

  const allFields = useMemo(() => {
    return { ...TASK_FIELDS, ...data };
  }, [data]);

  return (
    <ListEntityPicker
      entity={Entities.task}
      data={allFields}
      filterBy={['title']}
      sortBy={sortBy}
      sortByDirection={sortByDirection}
      {...rest}
      renderItemContent={(task: Task) => {
        return (
          <Tooltip title={task.title} showOnlyOnOverflow enterNextDelay={1000}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="body2" noWrap>
                {task.title}
              </Typography>

              <HookedUserIcon userId={task.userId} />
            </Box>
          </Tooltip>
        );
      }}
    />
  );
}

const TASK_FIELDS: Task<EMode.query> = {
  id: null,
  title: null,
  userId: null,
  status: null,
};
